import supply from './supply'
import supplyHistory from './history'
import plugins from './plugins'
import insurance from './insurance'
import document from './document'
export default {
  supply,
  supplyHistory,
  plugins,
  insurance,
  document
}
